import { render, staticRenderFns } from "./memberReferral.vue?vue&type=template&id=38949e77&scoped=true&"
import script from "./memberReferral.vue?vue&type=script&lang=js&"
export * from "./memberReferral.vue?vue&type=script&lang=js&"
import style0 from "./memberReferral.vue?vue&type=style&index=0&id=38949e77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38949e77",
  null
  
)

export default component.exports